var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.77936 0.451389C9.38121 -0.150463 10.357 -0.150463 10.9589 0.451389L12.0486 1.54114C12.6505 2.14299 12.6505 3.11879 12.0486 3.72064L11.0824 4.68685C11.0065 4.64929 10.9268 4.60868 10.844 4.56511C10.2871 4.2719 9.62614 3.86038 9.1329 3.36713C8.63965 2.87388 8.22812 2.21297 7.93491 1.65602C7.89134 1.57326 7.85072 1.49345 7.81316 1.41759L8.77936 0.451389ZM8.42579 4.07424C9.00947 4.65791 9.75177 5.11729 10.3396 5.42961L6.54003 9.22922C6.30424 9.46501 5.99833 9.61797 5.66823 9.66512L3.37975 9.99205C2.8712 10.0647 2.4353 9.6288 2.50795 9.12025L2.83488 6.83177C2.88203 6.50167 3.03499 6.19576 3.27078 5.95997L7.0704 2.16035C7.38271 2.74823 7.8421 3.49055 8.42579 4.07424ZM1 11C0.723858 11 0.5 11.2239 0.5 11.5C0.5 11.7761 0.723858 12 1 12H12C12.2761 12 12.5 11.7761 12.5 11.5C12.5 11.2239 12.2761 11 12 11H1Z",
    fill: "#F9FAFB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.6c1dc8b2.svg";
export { ForwardRef as ReactComponent };